export default function Col() {
  return {}
}
